import config from './config';

// fetch wrapper that adds the backend API key header to every request
export default function apiFetch(url, options = {}) {
    return fetch(url, {
        ...options,
        headers: {
            ...options.headers,
            'x-api-key': config.api_key
        }
    });
}
